import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

/** Pale grey bordered panel; `rounded` doubles the corner radius. */
export const MutedPanel = styled(Box, {
  shouldForwardProp: prop => prop !== 'rounded',
})<{ rounded?: boolean }>(({ theme, rounded }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[50],
  borderRadius: Number(theme.shape.borderRadius) * (rounded ? 2 : 1),
  border: `1px solid ${theme.palette.grey[200]}`,
}));
